<script>
	import { initializeApp } from "firebase/app";
	import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
	import { getAuth } from "firebase/auth";
	// import { getAnalytics, logEvent } from 'firebase/analytics';
	import { getAnalytics } from "firebase/analytics";
	import { getFirestore, collection, addDoc } from "firebase/firestore";
	import { getStorage } from "firebase/storage";
	import { firebaseConfig } from "../lib/firebaseConfig";
	import Login from "./Login.svelte";
	import Loader from "./Loader.svelte";
	import Game from "./Game.svelte";
	import Conclusion from "./Conclusion.svelte";
	import EscapeStandalone from "./EscapeStandalone.svelte";
	import VersionControl from "./VersionControl.svelte";
	// import LangModal from '../home/LangModal.svelte';
	// import Lang from '../common/Lang.svelte';

	// const { initializeApp } = require("firebase/app");

	// const app = initializeApp({
	//   // Your firebase configuration object
	// });

	// Pass your reCAPTCHA v3 site key (public key) to activate(). Make sure this
	// key is the counterpart to the secret key you set in the Firebase console.

	const firebaseApp = initializeApp(firebaseConfig);
	const analytics = getAnalytics(app);
	// const { initializeAppCheck, ReCaptchaV3Provider } = require('firebase/app-check');
	const auth = getAuth(app);
	// const analytics = getAnalytics();
	const db = getFirestore();
	const storage = getStorage(firebaseApp);
	const appCheck = initializeAppCheck(app, {
		provider: new ReCaptchaV3Provider(
			"6LccY4UfAAAAAI3JgHICpZsbbxZFqtzMCFSjIyOP",
		),
		// Optional argument. If true, the SDK automatically refreshes App Check
		// tokens as needed.
		isTokenAutoRefreshEnabled: true,
	});

	const v = "?rev=06171920";

	const locals = {
		en: "en",
		bg: "bg",
	};
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	let local = urlParams.get("l") || urlParams.get("lang") || navigator.language; //defaults to user's language if no language is set via link parameters
	export let hasPrefLangSet = false;
	export let lang = checkPreferedLang();
	$: lang, changeHTMLlang();

	let globalState = "login"; // i.e. login | game | conclusion | profile //localStorage.getItem('showConclusion') ? 'conclusion' :

	let user = {
		name: "",
		uid: "",
		photo:
			"https://firebasestorage.googleapis.com/v0/b/vutreshen-glas.appspot.com/o/vg-template%2Fvg-navigate.png?alt=media&token=f7a09181-690b-43e0-b2f9-a4ec2e6112ba",
		email: "",
	};
	let loader = true;
	$: document.body.classList[loader ? "add" : "remove"]("loader-noscroll");
	function handleLoader(e) {
		loader = e.detail;
	}

	function changeHTMLlang() {
		document.documentElement.lang = lang;
	}

	function handleState(e) {
		if (e.detail == "conclusion" && globalState !== "conclusion") {
			// location.reload(true);
		}
		globalState = e.detail;
	}

	export function checkPreferedLang() {
		if (localStorage.getItem("hasPreferedLang") === null) {
			hasPrefLangSet = false;
			return locals[local] || "bg"; //defaults to ~english~ BULGARIAN if the user's language or the link param. language is not in the list
		} else {
			if (localStorage.getItem("preferedLanguage") !== null) {
				hasPrefLangSet = true;
				return localStorage.getItem("preferedLanguage");
			}
		}
	}
	function setLang(l) {
		localStorage.setItem("hasPreferedLang", true);
		localStorage.setItem("preferedLanguage", l);
		lang = l;
	}

	function handleSetLang(event) {
		setLang(event.detail.lang);
		hasPrefLangSet = event.detail.prefset;
	}
	document.body.classList.add("obelisk-body");
</script>

<svelte:head>
	<script
		src="https://kit.fontawesome.com/51ec7a37fa.js"
		crossorigin="anonymous"
	></script>
</svelte:head>

<!-- <button on:click={() => (loader = true)}>loader</button> -->
{#if loader}
	<Loader on:loader={handleLoader} {loader} />
{/if}

<EscapeStandalone {lang}></EscapeStandalone>
<VersionControl {v} {db}></VersionControl>

{#if globalState === "login"}
	<Login
		{auth}
		{db}
		{storage}
		{user}
		{loader}
		{lang}
		{analytics}
		on:loader={handleLoader}
		on:setLang={handleSetLang}
		on:state={handleState}
	/>
{:else if globalState === "game"}
	<Game
		{v}
		{auth}
		{db}
		{storage}
		{user}
		{loader}
		{lang}
		{analytics}
		on:loader={handleLoader}
		on:setLang={handleSetLang}
		on:state={handleState}
	/>
{:else if globalState === "conclusion"}
	<Conclusion
		{auth}
		{db}
		{user}
		{loader}
		{lang}
		{analytics}
		on:loader={handleLoader}
		on:setLang={handleSetLang}
		on:state={handleState}
	/>
{:else}
	Something else - you should not see this...
{/if}

<!-- <div class="standalone"><p></p></div> -->

<style>
	* {
		color: white;
	}
	:global(.obelisk-body) {
		grid-template-rows: min-content auto min-content;
		word-break: break-word;
	}
	:global(.obelisk-body main) {
		padding-inline: 1rem;
		padding-top: 2rem;
	}
	:global(body.noscroll, body.loader-noscroll, body.standalone-noscroll) {
		overflow: hidden;
	}
</style>
